module.exports = __webpack_public_path__ + "img/KW.841518c8.svg";